"use strict";

var AJAX_URL;

if (location.host == 'lagrimas') {
  var BASEURL = 'http://lagrimas';
} else {
  var BASEURL = 'https://work.grundig9000.com';
}

AJAX_URL = BASEURL + '/wp-content/themes/lagrimas/javascript/ajax.php';
var doingAjax = false,
    lagrimas;

(function ($) {
  jQuery.fn.extend({
    lagrimas: function lagrimas(options) {
      this.thumb = function (el) {
        this.el = el;
        this.index = el.index();
        this.slides = $(this.el).find('div.thumbnail');
        this.a = $(this.el).find('a');
        this.slidecount = this.slides.length - 1;
        this.faderate = 1500;
        this.pause = Math.floor(Math.random() * 2000 + 4000);
        this.self = this;

        if ($('body').hasClass('home') || $('body').hasClass('tag')) {
          $(this.a).mouseover(function () {
            var tagsArr = $(this).parent().attr('data-tags').split(' ');

            for (var i = 0; i < tagsArr.length; i++) {
              $('nav#filter a[data-filter=' + tagsArr[i] + ']').addClass('highlight');
            }
          });
          $(this.a).mouseout(function () {
            $('nav#filter a').removeClass('highlight');
          });
        }

        $(this.a).mouseover(function () {
          $(this).parent().addClass('here');
        });
        $(this.a).mouseout(function () {
          $(this).parent().removeClass('here');
        });
        setTimeout($.proxy(function () {
          this.el.animate({
            opacity: 1
          }, 1000, $.proxy(function () {
            setTimeout($.proxy(function () {
              this.startSlides();
            }, this), Math.floor(Math.random() * 2000 + 4000));
          }, this));
        }, this), Math.floor(Math.random() * 1000));
        this.startSlides = $.proxy(function () {
          if (this.slidecount == 0) {
            this.slidecount = this.slides.length - 1;
            $(this.slides[this.slidecount]).fadeIn(this.faderate, $.proxy(function () {
              this.slides.show();
              this.timer = setTimeout(this.startSlides, this.pause);
            }, this));
          } else {
            $(this.slides[this.slidecount]).fadeOut(this.faderate, $.proxy(function () {
              this.slidecount--;
              this.timer = setTimeout(this.startSlides, this.pause);
            }, this));
          }
        }, this);
      };

      this.initContactForm = function () {
        $('input[name=name]').focus();
        $('form').validate({
          submitHandler: function submitHandler(form) {
            $('.bt_submit').addClass('disabled');
            $('div.error').remove();
            $.ajax({
              data: $(form).serialize() + '&action=message',
              success: function success(data) {
                $('#content').html('<div id="thanks">Thank you for your message.</div>');
              }
            });
          },
          invalidHandler: function invalidHandler() {
            $('.bt_submit').removeClass('disabled');
          }
        });
        $('.bt_submit').click(function () {
          if ($(this).hasClass('disabled')) {
            return;
          }

          $(this).parents('form').submit();
        });
      };

      return {
        thumb: this.thumb,
        initContactForm: this.initContactForm
      };
    }
  });
})(jQuery);

jQuery(document).ready(function ($) {
  lagrimas = $(document).lagrimas();
  $(document).ajaxStart(function () {
    $("html").addClass("wait");
    doingAjax = true;
  });
  $(document).ajaxStop(function () {
    $("html").removeClass("wait");
    doingAjax = false;
  });
  $.ajaxSetup({
    url: AJAX_URL,
    type: "POST"
  });
  initPage();

  if (location.pathname.indexOf('angular') < 0) {
    window.onpopstate = function (e) {
      e.preventDefault();

      if (e.state.href) {
        swapContent(e.state.href);
      }
    };
  }

  function initPage() {
    $('#thumbs article').each(function () {
      new lagrimas.thumb($(this));
    });

    if (location.pathname.indexOf('angular') < 0) {
      $('a.ajax').click(function (e) {
        e.preventDefault();

        if ($(this).hasClass('here')) {
          return;
        }

        var href = $(this).attr('href');
        swapContent(href);
      });
    }
  }

  function swapContent(href) {
    if (doingAjax) {
      return;
    }

    $.ajax({
      data: {
        action: 'swap_content',
        foo: href
      },
      success: function success(data) {
        document.title = data.title;
        var bits = href.split('/');
        var page = bits[bits.length - 2];
        var state = {
          page: page,
          href: href
        };

        if (window.history.state === null || window.history.state.page != page) {
          window.history.pushState(state, document.title, href);
        }

        window.scrollTo(0, 0);
        $('#main').html(data.content);
        $('body').attr('class', data.bodyClass);
        $('#thumbs article').css({
          opacity: 1
        });
        $('a').removeClass('here');
        $('a[href$="' + href + '"]').addClass('here');
        initPage();
      }
    });
  } //CONTACT FORM


  if ($('body').hasClass('contact')) {
    lagrimas.initContactForm();
  }
}); //end jQuery document ready

function $c(t) {
  console.log(t);
}